import { adressevaelgerApiSlice as api } from "../../../apiSlice";
export const addTagTypes = [] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      searchAdresser: build.query<
        SearchAdresserApiResponse,
        SearchAdresserApiArg
      >({
        query: (queryArg) => ({
          url: `/adresser/soeg`,
          params: {
            tekst: queryArg.tekst,
            token: queryArg.token,
            medtagForeloebige: queryArg.medtagForeloebige,
            maksimum: queryArg.maksimum,
            kommuneKode: queryArg.kommuneKode,
            vejnavn: queryArg.vejnavn,
            postnummer: queryArg.postnummer,
          },
        }),
        providesTags: [],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as adressevaelgerOpenApi };
export type SearchAdresserApiResponse =
  /** status 200 Search result. Note: the upstream API returns HTTP 200 even for application-level errors - check `status` on the response body. */ AdresseSearchResult;
export type SearchAdresserApiArg = {
  /** Free-text search input, e.g. a partial street name and/or house number. */
  tekst: string;
  /** Placeholder value client-side - the BFF proxy (/adressevaelger) always overwrites this with the real, server-side-only token before forwarding the request. */
  token: string;
  /** Whether to include provisional (foreløbige) addresses in the result. */
  medtagForeloebige?: boolean;
  /** Maximum number of suggestions to return. */
  maksimum?: number;
  /** Restrict the search to a specific municipality code. */
  kommuneKode?: string;
  /** Restrict the search to a specific street name. */
  vejnavn?: string;
  /** Restrict the search to a specific zip code. */
  postnummer?: string;
};
export type AdresseSuggestion = {
  id: string;
  /** e.g. 'adresse', 'vejnavn', 'navngivenvejpostnummer', 'husnummer'. Suggestions whose type is one of ADRESSEVAELGER_REFINEMENT_TYPES are not yet a fully resolved address and require another round of searching. */
  type: string;
  titel: string;
  [key: string]: any;
};
export type AdresseSearchResult = {
  status: "ok" | "fejl";
  fund?: AdresseSuggestion[];
  /** Present when status is 'fejl'. */
  beskrivelse?: string;
};
export const { useSearchAdresserQuery } = injectedRtkApi;
